import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Alert,
  Grid
} from '@mui/material';
import { api } from '../../services/api';

const MarginCoursePage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [currentValue, setCurrentValue] = useState<string>('');
  const [newValue, setNewValue] = useState<string>('');

  const loadCurrentValue = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.get('/api/v1/admin-panel/currency/rubt', {
        headers: {
          'x-hasura-admin-secret': localStorage.getItem('hasura_admin_secret') || 'admin_secret_key'
        }
      });

      setCurrentValue(response.data?.data || '');
    } catch (err: any) {
      console.error('Error loading RUBT course:', err);
      setError(err.response?.data?.message || err.message || 'Ошибка при загрузке курса RUBT');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError(null);

      await api.post('/api/v1/admin-panel/currency/rubt', 
        { value: newValue ? parseFloat(newValue) : null },
        {
          headers: {
            'x-hasura-admin-secret': localStorage.getItem('hasura_admin_secret') || 'admin_secret_key'
          }
        }
      );

      await loadCurrentValue();
      setNewValue('');
    } catch (err: any) {
      console.error('Error setting RUBT course:', err);
      setError(err.response?.data?.message || err.message || 'Ошибка при установке курса RUBT');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCurrentValue();

    const intervalId = setInterval(() => {
      loadCurrentValue();
    }, 10000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Контроль курса RUBT
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Текущий курс RUBT
            </Typography>
            <Typography variant="h3" color="primary" gutterBottom>
              {currentValue || 'Не установлен'}
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Установить новый курс
            </Typography>
            
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
              <TextField
                label="Новое значение курса"
                value={newValue}
                onChange={(e) => setNewValue(e.target.value)}
                type="number"
                inputProps={{ step: '0.01' }}
                sx={{ minWidth: 200 }}
                disabled={loading}
              />
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={loading || !newValue}
              >
                Установить
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={() => {
                  setNewValue('');
                  handleSubmit();
                }}
                disabled={loading}
              >
                Удалить курс
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MarginCoursePage;
